import { z } from 'zod';

import { emailReg, INVALID_EMAIL, REQUIRED } from '@/components/Form/validation';

// Every field here is required by the endpoint's own model — all five are
// declared `required=True, min_length=1`, and the app validates that model
// globally — so none of these rules is a second source of truth. They only say
// the same thing earlier, under the field instead of in a native browser bubble
// that speaks the browser's language rather than the app's.
export const organizationFormSchema = z.object({
  name: z.string().trim().min(1, REQUIRED),
  // Picked from a fixed list, never typed, so there is nothing to trim.
  country: z.string().min(1, REQUIRED),
  first_name: z.string().trim().min(1, REQUIRED),
  last_name: z.string().trim().min(1, REQUIRED),
  email: z.string().trim().min(1, REQUIRED).regex(emailReg, INVALID_EMAIL),
});

export type OrganizationFormValues = z.infer<typeof organizationFormSchema>;
